
const MultiFieldSelector = ({
    data,
    onChange,
    label = "Eye",
    disabled
}) => {
    return (
        <div className="space-y-2">
            <span className="text-sm font-semibold text-gray-700 flex items-center justify-center">
                {label}
            </span>

            {/* TOP TEXT INPUT (NO LABEL INSIDE) */}
            <textarea
                type="text"
                value={data?.text || ""}
                onChange={(e) =>
                    onChange("text", e.target.value)
                }
                placeholder="Enter text..."
                className={`w-full px-2 py-2 border-0 border-b-2 rounded-md overflow-hidden resize-none
                focus:outline-none focus:ring-2 focus:ring-blue-600
                bg-slate-50 
                ${disabled ? "!text-black !opacity-100 font-small" : "font-medium"}
                `}
            />

        

            {/* PILLS ROW */}
            <div className="flex gap-2 flex-wrap">
                {/* KENALOG & MOXI TOGGLE */}
                <button
                    type="button"
                    onClick={() =>
                        onChange(
                            "KENALOG & MOXI",
                            data?.["KENALOG & MOXI"]
                                ? ""
                                : "KENALOG & MOXI"
                        )
                    }
                    className={`
                        px-4 py-1.5 rounded-full text-xs font-medium
                        border transition-all duration-200
                        ${data?.["KENALOG & MOXI"]
                            ? "bg-blue-600 border-blue-600 text-white"
                            : "bg-white border-gray-300 text-gray-600"
                        }
                    `}
                >
                    KENALOG & MOXI
                </button>

                {/* DROPS TOGGLE */}
                <button
                    type="button"
                    onClick={() =>
                        onChange("+drops", !data?.["+drops"])
                    }
                    className={`
                        px-4 py-1.5 rounded-full text-xs font-medium
                        border transition-all duration-200
                        ${data?.["+drops"]
                            ? "bg-blue-600 border-blue-600 text-white"
                            : "bg-white border-gray-300 text-gray-600"
                        }
                    `}
                >
                    DROPS
                </button>
            </div>
        </div>
    );
};

export default MultiFieldSelector;